"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.Icon = void 0;
var vdom_1 = require("@dojo/framework/core/vdom");
var theme_1 = require("@dojo/widgets/middleware/theme");
var util_1 = require("@dojo/widgets/common/util");
var icon_m_css_1 = require("../css/icon.m.css");
var base_m_css_1 = require("../css/base.m.css");
var factory = vdom_1.create({ theme: theme_1["default"] }).properties();
exports.Icon = factory(function Icon(_a) {
    var id = _a.id, properties = _a.properties, theme = _a.middleware.theme;
    var _b = properties(), _c = _b.aria, aria = _c === void 0 ? {
        hidden: 'true'
    } : _c, faname = _b.faname, altText = _b.altText, spin = _b.spin, rotate = _b.rotate, size = _b.size, xqa = _b.xqa, onOver = _b.onOver, onOut = _b.onOut, onBlur = _b.onBlur, onFocus = _b.onFocus;
    var classes = theme.classes(icon_m_css_1["default"]);
    var fapre = 'fas';
    var sizeClass = size ? "fa-" + size : undefined;
    var spinning = spin ? 'fa-spin' : undefined;
    var rotated = rotate ? "fa-rotate-" + rotate : undefined;
    return vdom_1.v('i', __assign({ key: id, xqa: xqa, role: 'img', classes: [classes.root, fapre, "fa-" + faname, spinning, rotated, sizeClass].filter(function (v) { return Boolean(v); }), onpointerenter: function () { return onOver && onOver(); }, onpointerleave: function () { return onOut && onOut(); }, onblur: function () { return onBlur && onBlur(); }, onfocus: function () { return onFocus && onFocus(); } }, util_1.formatAriaProperties(aria)), [altText ? vdom_1.v('span', { classes: [base_m_css_1["default"].visuallyHidden] }, [altText]) : null]);
});
exports["default"] = exports.Icon;
